import { useLanguage } from '@/lib/LanguageContext';
import translations from '@/lib/translations';

const useTranslation = () => {
  const { language } = useLanguage();
  
  const t = (key) => {
    if (!translations[language]) {
      console.warn(`Translation missing for language: ${language}`);
      return key;
    }
    
    if (!translations[language][key]) {
      console.warn(`Translation key missing: ${key} for language: ${language}`);
      return key;
    }
    
    return translations[language][key];
  };
  
  return { t, language };
};

export default useTranslation; 